import './style.css';
import Slide from "../components/slider/slide";
import DesignBuild from '../components/designBuild/designBuild';
import ContactUs from '../components/cantactUs/contactUs';


function CantactUsPage (){

  return (
    <section > 
      <div className="CantacUs">
        <ContactUs/>
      </div>
    </section>
  )
}
export default CantactUsPage;